{#each cards as card (card.value)}
  <div class="{config.id}-user-card card">
    <p class="form-row form-row-wide">
      <label>
        <input type='radio' bind:group={selected_card} value={card.value} name="{config.id}-card-info" disabled={loading}>
        <span class="card-brand card-brand-{card.brand}">{card.brand}</span> terminado em <span class="card-numbers">{card.last_numbers}</span>
      </label>
    </p>

    {#if card.value == selected_card}
      {#if 2 == card.version}
        <input name="{config.id}-cvc" type="hidden" value="999">
        <div style="display: none !important;">{$cardForm.cvc = 999}</div>
      {:else}
        <p class="form-row form-row-wide">
          <label for="{config.id}-cvc">Código de Segurança <span class="required">*</span></label>
          <input id="{config.id}-cvc" name="{config.id}-cvc" class="input-text" type="number" maxlength="4" bind:value={$cardForm.cvc} min=0 readonly={loading}>
        </p>
      {/if}
    {/if}

    <button class="button button-delete-card" type="button" id="{config.id}-delete-card" title="Remover este cartão de crédito" on:click={e => deleteCard(e, card.value)} disabled={loading}>&times;</button>
  </div>
{/each}

{#if Object.keys($installments).length > 0}
  <p class="form-row form-row-wide">
    <label for="{config.id}-installments">Número de parcelas</label>
    <select id="{config.id}-installments" name="{config.id}-installments" class="input-select" readonly={loading}>
      {#each Object.keys($installments) as i}
        <option value="{i}">
          {$installments[i]}
        </option>
      {/each}
    </select>
  </p>
{:else}
  <input type="hidden" name="{config.id}-installments" value="1">
{/if}

<input type="hidden" name="{config.id}-checkout-mode" value="list">

{#if error}
  <p class="form-row form-row-wide woocommerce-error">
    {error}
  </p>
{/if}

<button class="button" on:click={() => dispatch('registerCard')} disabled={loading}>Usar outro cartão de crédito</button>

<script>
  export let config = {};

  import { createEventDispatcher } from 'svelte';
  import { onMount, onDestroy } from 'svelte';
  import { formatNumber } from '../utils/format-number.js';
  import { cardForm, installments, waitingCardValidation } from './stores.js'

  const dispatch = createEventDispatcher();

  let selected_card = '';
  let cards = config.credit_cards;
  let error = '';

  $: if (cards.length == 0) {
    dispatch('registerCard');
  }

  $: loading = $waitingCardValidation;
  $: config.credit_cards = cards;

  $: if (selected_card) {
    $cardForm = {
      selected: selected_card,
      cvc: '',
    };
  }

  $: if ($waitingCardValidation) {
      const cvc = $cardForm.cvc ? $cardForm.cvc + '': '';
      if (!selected_card) {
        error = 'Selecione um cartão de crédito ou cadastre um novo.'
      }
      else if (cvc && cvc.length < 3) {
        error = 'O código de segurança deve ter no mínimo 3 digitos.'
      }
      $waitingCardValidation = false
  }

  const deleteCard = (e, card_info) => {
    const ajax_action = config.ajax.remove_user_credit_card;
    const data = {
      action: ajax_action.action,
      [ajax_action.nonce.param]: ajax_action.nonce.value,
      card_info: card_info
    }
    const parent = jQuery(e.target).parents('.wc-payment-form')

    parent.block({
      message: null,
      overlayCSS: {
        background: '#fff',
        opacity: 0.6
      }
    });

    if ( selected_card == card_info ) {
      selected_card = ''
    }

    const req = jQuery.ajax({
      url: config.ajax_url,
      type: 'POST',
      data,
    });

    req.always(function () {
      parent.unblock();
    });

    req.done(function (res) {
      if (res.success) {
        cards = cards.filter((card) => card.value != card_info)
      } else {
        console.error(res)
      }
    });

    req.fail(function () {
      console.error(req)
    })
  }
</script>

<style>
  .form-row :global(input[type=radio]) {
    margin-right: 5px;
  }

  .card {
    position: relative;
  }

  .button-delete-card {
    position: absolute;
    right: 0;
    top: 0;
  }
</style>
